<router-outlet />

<p-toast key="mainToast" />

<p-confirmDialog
    class="ruts-confirm-dialog"
    position="center"
    rejectButtonStyleClass="p-button-outlined"
    [style]="{ width: '490px' }" />
